export const removerPontosETracos = (value) => value.normalize('NFD').replace(/\D/g, '');

export default removerPontosETracos;
